import { autoserialize } from 'cerialize';

export class ClientFeeScheduleDetail {
  @autoserialize
  riderCancellationFee: number;
}
